import { createClient } from '@supabase/supabase-js';

// Supabase configuration
// These will be set via environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Debug logging (only in development)
if (process.env.NODE_ENV === 'development' && !supabaseUrl && !supabaseAnonKey) {
  console.warn('⚠️ Supabase not configured. Using localStorage fallback.');
}

// Create Supabase client with fallback dummy values if not configured
// This prevents errors when Supabase is not set up yet
const safeUrl = supabaseUrl || 'https://placeholder.supabase.co';
const safeKey = supabaseAnonKey || 'placeholder-key';

// Create Supabase client
export const supabase = createClient(safeUrl, safeKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Export a flag to check if Supabase is properly configured
export const isSupabaseConfigured = () => {
  return !!(supabaseUrl && supabaseAnonKey);
};
